const STORAGE_PREFIX = 'percurso:flag:';

// Flags locais (docs/plans/overhaul-ux-atlas-vivo.md + atlas-vivo-producao.md).
// Query param sempre vence. Sem param: localStorage; se ausente, usa `defaultEnabled`.
export const isFlagEnabled = (
  name,
  { search = window.location.search, defaultEnabled = false } = {}
) => {
  const params = new URLSearchParams(search);
  if (params.has(name)) {
    return params.get(name) !== '0' && params.get(name) !== 'false';
  }
  try {
    const stored = window.localStorage.getItem(`${STORAGE_PREFIX}${name}`);
    if (stored === '1') return true;
    if (stored === '0') return false;
  } catch {
    // localStorage indisponível — cai no default
  }
  return defaultEnabled;
};

// Atlas Vivo é o shell padrão de produção (Épico 29). Em AppMainView o layout
// é sempre AtlasVivoLayout (nedi-telas 1.5) — `?atlasVivo=0` / localStorage
// ainda podem afetar outros seams (import routing), mas não trocam o shell.
// `isProduction` injetável p/ testes (import.meta.env.PROD é estático no Vite).
export const isAtlasVivoEnabled = (options = {}) => {
  const { isProduction = import.meta.env.PROD, ...flagOptions } = options;
  if (isProduction) {
    return true;
  }
  return isFlagEnabled('atlasVivo', { defaultEnabled: true, ...flagOptions });
};
